import type React from 'react';

import { TargetedPetitionList } from './TargetedPetitionList';

export const TargetedPetitionListWrapper: React.FC = () => {
	// TODO: Restructure: remove wrapper: https://change.atlassian.net/browse/CHANGE-86589
	return <TargetedPetitionList />;
};
